import React from 'react';

const Footer = () => {
  return (
    <div className="footer">
      <p>© 2023 Legion Tech LLC. All rights reserved.</p>
    </div>
  );
};

export default Footer;
